export enum CardinalPronounsType {
  One = 'one',
  Few = 'few',
  Many = 'many',
  Empty = 'empty',
}
